import React, { PropTypes } from 'react';
import idx from 'idx';
import AdminImageNameTile from 'admin/components/entries/image_name_tile';
import AdminNameDenseItem from 'admin/components/entries/name_dense_item';
import ProfileImageNameTile from 'profile/components/your_entries/image_name_tile';
import ProfileNameDenseItem from 'profile/components/your_entries/name_dense_item';
import ImageNameTile from 'entries/containers/image_name_tile';
import NameDenseItem from 'entries/containers/name_dense_item';
import FeedbackTile from 'entries/components/feedback_tile';
import FGImageNameTile from 'focus_groups/containers/image_name_tile';
import PresentationImageNameTile from 'presentations/containers/image_name_tile';

const MAP = {
  image: {
    grid: {
      projectEntries: {
        standard: ImageNameTile,
        feedback: FeedbackTile
      },
      adminProjectEntries: {
        standard: AdminImageNameTile
      },
      adminUserEntries: {
        standard: AdminImageNameTile
      },
      profileEntries: {
        standard: ProfileImageNameTile
      },
      focusGroupEntries: {
        standard: FGImageNameTile
      },
      presentationEntries: {
        standard: PresentationImageNameTile
      }
    },
    list: {
      projectEntries: {
        standard: ImageNameTile,
        feedback: FeedbackTile
      },
      adminProjectEntries: {
        standard: AdminImageNameTile
      },
      adminUserEntries: {
        standard: AdminImageNameTile
      },
      profileEntries: {
        standard: ProfileImageNameTile
      }
    }
  },
  name: {
    list: {
      projectEntries: {
        standard: ImageNameTile,
        feedback: FeedbackTile
      },
      adminProjectEntries: {
        standard: AdminImageNameTile
      },
      adminUserEntries: {
        standard: AdminImageNameTile
      },
      profileEntries: {
        standard: ProfileImageNameTile
      }
    },
    dense: {
      projectEntries: {
        standard: NameDenseItem
      },
      adminProjectEntries: {
        standard: AdminNameDenseItem
      },
      adminUserEntries: {
        standard: AdminNameDenseItem
      },
      profileEntries: {
        standard: ProfileNameDenseItem
      }
    }
  }
};

const Item = ({ entryType, viewType, variation, item, grouped, onItemClick }) => {
  /* item is missing or doesn't have revisions */
  if (!item || (!item.isFeedback && (!item.revisions || item.revisions.length === 0))) {
    return null;
  }

  const Component = idx(
    MAP, _ => _[entryType][viewType][variation][item.isFeedback? "feedback" : "standard"]
  );

  if (!Component) {
    return null;
  }

  return <Component {...{ item, entryType, viewType, variation, grouped, onClick: onItemClick }} />;
}

Item.propTypes = {
  item: PropTypes.object,
  variation: PropTypes.string.isRequired,
  viewType: PropTypes.string.isRequired,
  entryType: PropTypes.string.isRequired,
  grouped: PropTypes.bool,
  onItemClick: PropTypes.func,
};

export default Item;



// WEBPACK FOOTER //
// ./common/components/entry_gallery/item.jsx